import React from 'react';
import { MailIcon, MapPinIcon, PhoneIcon } from 'lucide-react';
import { contact } from '../../data/site';
import { nextSteps } from '../../data/process';
import { ContactForm } from '../forms/ContactForm';
import { Reveal } from '../ui/Reveal';
export function Contact() {
  return <section id="contact" aria-labelledby="contact-title" className="relative overflow-hidden bg-afb-night text-white" data-id="element-186" data-mp="1mwisf6ah7phd">
      <div aria-hidden="true" className="dot-field absolute inset-0" data-id="element-187" data-mp="18wq41hmf9lck" />
      <div className="relative mx-auto grid max-w-page gap-12 px-5 py-20 lg:grid-cols-[0.85fr_1.15fr] lg:gap-16 lg:px-8 lg:py-28" data-id="element-188" data-mp="1dw2s25p14ygq">
        <Reveal data-id="element-189" data-mp="zx2z4luhhxer">
          <h2 id="contact-title" className="font-sora text-[2rem] font-semibold leading-[1.1] tracking-[-0.02em] md:text-[2.75rem]" data-id="element-190" data-mp="zxmim6zs8tuw">
            Tell us about your site.
          </h2>
          <p className="mt-5 text-lg leading-relaxed text-white/70" data-id="element-191" data-mp="2ub431l4w5alp">
            An engineer, not a call centre, will reply within 48 hours.
          </p>

          <ul className="mt-10 space-y-5 text-[15px]" data-id="element-192" data-mp="2b7omjv5tt5qr">
            <li data-id="element-193" data-mp="2b63s05jihmsw">
              <a href={contact.phoneHref} className="group flex items-center gap-4" data-id="element-194" data-mp="269n51eo1tehe">
                <span className="flex h-11 w-11 items-center justify-center rounded-btn border border-white/15 text-afb-turquoise" data-id="element-195" data-mp="267j0qvm8mdgl">
                  <PhoneIcon aria-hidden="true" className="h-5 w-5" data-id="element-196" data-mp="2fywwqtezcv4z" />
                </span>
                <span data-id="element-197" data-mp="1s92n0kpyjmoy">
                  <span className="block text-white/60" data-id="element-198" data-mp="1sadp8g3r8mdy">Call</span>
                  <span className="font-semibold text-white group-hover:underline" data-id="element-199" data-mp="1narf4fj83m9d">{contact.phoneDisplay}</span>
                </span>
              </a>
            </li>
            <li data-id="element-200" data-mp="225p6b52my5ov">
              <a href={contact.emailHref} className="group flex items-center gap-4" data-id="element-201" data-mp="1x8p10wdm16yt">
                <span className="flex h-11 w-11 items-center justify-center rounded-btn border border-white/15 text-afb-turquoise" data-id="element-202" data-mp="1xb1rjxxfopnh">
                  <MailIcon aria-hidden="true" className="h-5 w-5" data-id="element-203" data-mp="38odn7lj1i1yk" />
                </span>
                <span data-id="element-204" data-mp="3fran17rhhdb9">
                  <span className="block text-white/60" data-id="element-205" data-mp="3fq0pcjojm755">Email</span>
                  <span className="font-semibold text-white group-hover:underline" data-id="element-206" data-mp="3kpveahorcmnk">{contact.email}</span>
                </span>
              </a>
            </li>
            <li className="flex items-center gap-4" data-id="element-207" data-mp="3ppzwcc5bdpfw">
              <span className="flex h-11 w-11 items-center justify-center rounded-btn border border-white/15 text-afb-turquoise" data-id="element-208" data-mp="3uounc1dfqkb3">
                <MapPinIcon aria-hidden="true" className="h-5 w-5" data-id="element-209" data-mp="2x243jiiv8hoe" />
              </span>
              <span data-id="element-210" data-mp="320fddt95us6m">
                <span className="block text-white/60" data-id="element-211" data-mp="31zx9cag9b9o5">Visit</span>
                <span className="font-semibold text-white" data-id="element-212" data-mp="36xpbdxam8c62">
                  {contact.street}, {contact.locality} {contact.region} {contact.postcode}
                </span>
              </span>
            </li>
          </ul>

          <div className="mt-12 border-t border-white/10 pt-8" data-id="element-213" data-mp="2e9jnj1o9m720">
            <h3 className="font-sora text-lg font-semibold" data-id="element-214" data-mp="2j8ct87xb8trm">What happens next</h3>
            <ol className="mt-5 space-y-4" data-id="element-215" data-mp="10drrvqcjxcbn">
              {nextSteps.map((step, index) => <li key={step.title} className="flex gap-4" data-id="element-216" data-mp="wcpr352zks7k" data-mpi={index}>
                  <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-white/10 font-sora text-xs font-semibold" data-id="element-217" data-mp="wd7v4nvw4aq1">
                    {index + 1}
                  </span>
                  <div data-id="element-218" data-mp="me0mge03p499">
                    <p className="font-semibold" data-id="element-219" data-mp="hf5qead4hj77">{step.title}</p>
                    <p className="text-sm text-white/65" data-id="element-220" data-mp="hgqp8c6gzoav">{step.detail}</p>
                  </div>
                </li>)}
            </ol>
          </div>
        </Reveal>

        <Reveal delay={60} data-id="element-221" data-mp="8nnck63nffha">
          <div className="rounded-card bg-white p-6 text-afb-ink md:p-10" data-id="element-222" data-mp="8kre8gnw2osb">
            <ContactForm data-id="element-223" data-mp="3p28fvla0bnk" />
          </div>
        </Reveal>
      </div>
    </section>;
}